import messages from '../../messages/messages.en'
import './sandbox.css'
import { useLocation } from 'react-router-dom'

export default function SandboxThankyou() {
    const location = useLocation();
    const route = location.pathname.includes("registered") ? "registered" : "confirmed"
    return <div>
        <div className="thankyou-page">
            <div className="thankyou-box">
                <h2>{messages.sandbox[route].title}</h2>
                {messages.sandbox[route].body.map((a) => (<div>{a}</div>))}
                <div>
                    <a href="https://www.isara.com">www.isara.com</a>
                </div>
            </div>
        </div>
    </div>
}